import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AboutUs} from '../../model/aboutUs';
import {UtilService} from '../../service/util.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  about: Observable<AboutUs>;

  constructor(private http: HttpClient, private util: UtilService) {
  }

  ngOnInit(): void {
    this.getAboutUs();
  }

  getAboutUs() {
    this.about = this.http.get<AboutUs>(this.util.getUrl('aboutUs.json'));
  }

}
